import React, { useState } from "react";
import { balanceCarouselData, transactionItems } from "utils/constants";

import BalanceCarousel from "./Carousels/balance-carousel";
import FadeIn from "./common/FadeInEffect";

function AtFingerTipsComponent({ deviceType }) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex flex-col items-center text-center px-6 sm:px-0">
      <FadeIn>
        <h2 className="text-size-6 lg:text-6xl 3xl:text-size-9 4xl:text-size-11 4xl:leading-124 4xl:mb-20 lg:mb-[70px] mb-[52px] font-normal font-ppNeue font-no-common-ligature">
          At your fingertips
        </h2>
      </FadeIn>

      <FadeIn duration={0.4}>
        <p className="text-base lg:text-xl 3xl:text-2xl 4xl:text-size-4/5 font-normal h-9 3xl:h-12">
          {transactionItems[activeIndex] || transactionItems[0]}
        </p>
      </FadeIn>
      <BalanceCarousel
        deviceType={deviceType}
        streams={balanceCarouselData}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
      />
    </div>
  );
}

export default AtFingerTipsComponent;
